import React from 'react';
import {Grid, Typography} from "@mui/material";

export type PageTitleProps = {
    title: string;
};

const PageTitle: React.FC<PageTitleProps> = (props) => {
    return (
        <Typography variant="h4" gutterBottom>
            {props.title}
        </Typography>
    );
};
export default PageTitle;